import { Component } from '@angular/core';

@Component({
  selector: 'r2e-google-icon',
  templateUrl: './google-icon.component.svg',
  styles: 'svg { height: 100%; min-height: 1.5rem; }'
})
export class GoogleIconComponent {}
